<digital-platform-dynamic-content-wrapper
  *ngFor="let config of pageContent$ | async"
  [config]="config"
>
</digital-platform-dynamic-content-wrapper>
